const required = value => (value ? undefined : "Required");

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const minLength = min => value =>
  value && value.length < min ? `At least ${min} characters` : undefined;

const number = value => (value && isNaN(Number(value)) ? "Must be a number" : undefined);

const minValue = min => value => (value && value < min ? `Must be at least ${min}` : undefined);

const pattern = pattern => {
  if (!pattern) return () => undefined; // Allow empty values
  // eslint-disable-next-line security/detect-non-literal-regexp
  const regex = new RegExp(pattern, "i"); // Create a safe regex
  return value => (regex.test(value) ? undefined : "Invalid value");
};

export const getValidations = validation => {
  const validations = [];
  if (!validation) return [];
  if (validation.required) {
    validations.push(required);
  }
  if (validation.maxLength > 0) {
    validations.push(maxLength(validation.maxLength));
  }
  if (validation.minLength > 0) {
    validations.push(minLength(validation.minLength));
  }
  if (validation.pattern) {
    validations.push(pattern(pattern));
  }

  return validations;
};



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/validations.js